<template>
  <article
    :class="[
      $style.config,
      $style.container,
      data?.fields?.link && $style.linked,
    ]"
    @click="(e) => $handleBlockLinkClick(e, cardLinkEl?.$el)"
  >
    <BasePicture
      :src="data?.fields?.image?.fields?.file?.url + `?w=570&fit=thumb`"
      alt=""
      :img-class="$style.img"
    />

    <div :class="$style.content">
      <BaseHeading size="h6" :class="$style.title">
        <NuxtLinkLocale
          v-if="data?.fields?.link"
          ref="cardLink"
          :to="data?.fields?.link"
          :target="
            data?.fields?.link?.startsWith?.('http') ? '_blank' : undefined
          "
        >
          {{ data?.fields?.header }}
        </NuxtLinkLocale>
        <template v-else>
          {{ data?.fields?.header }}
        </template>
      </BaseHeading>

      <MarkedParser :class="$style.copy" :md="data?.fields?.copy" />
    </div>
  </article>
</template>

<script setup lang="ts">
import type { TypeMediaWithoutUnresolvableLinksResponse } from '~/types/contentful'

const { $handleBlockLinkClick } = useNuxtApp()

const cardLinkEl = useTemplateRef<ComponentPublicInstance | null>('cardLink')

defineProps<{
  data: TypeMediaWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.config {
  --padding--base: 16px;
  --padding--lg: 23px;
}

.container {
  @include fluid-type(21px, 23px);
  background: #fff;
  border: 1px solid var(--gray-4);
  box-shadow: 0 4px 13px rgba(#000, 0.06);
  display: grid;
  gap: 10px;
  transition: cubic-bezier(0.16, 1, 0.29, 0.99) 0.2s;
  min-height: 145px;

  @include media('xs') {
    grid-template-columns: 222px 1fr;
  }

  @include media('sm') {
    grid-template-columns: 1fr;
  }

  @include media('md') {
    grid-template-columns: 222px 1fr;
  }

  &.linked {
    cursor: pointer;

    &:hover,
    &:focus {
      border: 1px solid var(--purple);
    }
  }
}

.img {
  width: 100%;
  vertical-align: middle;

  @include media('xs') {
    height: 100%;
    object-fit: cover;
    width: auto;
  }
}

.content {
  @include fluid-type(17px, 17px);
  line-height: math.div(27px, 17px);
  padding: var(--padding--base);

  @include media('lg') {
    padding: var(--padding--lg);
  }
}

.title {
  a {
    color: inherit;
  }
}

.cta {
  margin-top: 17px;
}
</style>
